import React, { useEffect, useState, useRef } from 'react'
import './index.less'
import {
  ErrorPlaceholder,
  EmptyPlaceholder,
} from "../../../../components/placeholder"
import LoadingPage from "../../../../components/loading-page"
import TabsBar from '../../components/tabs-bar'
import {
  getParamsFromHash
} from '../../../../utils/common'
import { DEFAULT_ERROR_MSG } from '../../config'
import {
  GetMemberGoods
} from '../../api'
import { trackGdp } from '../../../../utils/gio-report';

// 特权说明页可能会作为VIP首页底部配置的说明图片跳转的目标页面，会带上tab参数，需要取query参数默认选中对应tab
// 这里定义了一套key，用于匹配tab参数，如果tab参数不匹配，会默认选中第一个tab
// price | coupon | campaign
const App = () => {
  const tabList = ['price', 'coupon', 'campaign']
  const queryTab = getParamsFromHash('tab')
  const tab = tabList.includes(queryTab) ? queryTab : 'price'

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isEmptyPage, setIsEmptyPage] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const [tabConfig, setTabConfig] = useState<any[]>([])
  const [imgUrl, setImgUrl] = useState('')

  useEffect(() => {
    document.title = '特权说明'

    setIsLoading(true)
    getMemberGoods()

    trackGdp('P11224', 'B001', {
      tabType: tab
    })
  }, [])


  const getMemberGoods = async () => {
    try {
      const res: any = await GetMemberGoods()
      if (res.code === 200) {
        setIsLoading(false)
        const data = res.data
        const config = [
          {
            key: 'price',
            title: data?.vipPricePrivilegeDesc?.title,
            onClick: () => {
              setImgUrl(data?.vipPricePrivilegeDesc?.contentImgUrl)
              trackGdp('P11224', 'B001', {
                tabType: 'price'
              })
            }
          },
          {
            key: 'coupon',
            title: data?.couponPackPrivilegeDesc?.title,
            onClick: () => {
              setImgUrl(data?.couponPackPrivilegeDesc?.contentImgUrl)
              trackGdp('P11224', 'B001', {
                tabType: 'coupon'
              })
            }
          },
          {
            key: 'campaign',
            title: data?.activityPrivilegeDesc?.title,
            onClick: () => {
              setImgUrl(data?.activityPrivilegeDesc?.contentImgUrl)
              trackGdp('P11224', 'B001', {
                tabType: 'campaign'
              })
            }
          }
        ]
        setTabConfig(config)
        const tabItem = config.find(item => item.key === tab)
        if (tabItem) {
          tabItem.onClick()
        } else {
          config[0].onClick()
        }
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    } catch (error) {
      console.log('getMemberGoods error -->', error)
      setIsLoading(false)
      setErrorMsg(DEFAULT_ERROR_MSG)
      setIsLoadingError(true)
    }
  }

  if (isLoading)
    return (
      <LoadingPage />
    )

  if (isLoadingError)
    return (
      <ErrorPlaceholder
        message={errorMsg}
      ></ErrorPlaceholder>
    )

  if (isEmptyPage)
    return (
      <EmptyPlaceholder text={errorMsg}></EmptyPlaceholder>
    )

  return (
    <div className='charge-vip-privilege'>
      <TabsBar tabItems={tabConfig} firstShowTabKey={tab} className='top-bar'/>
      <div className='content'>
        <img alt='' className='image' src={imgUrl} />
      </div>
    </div>
  )
}

export default App